import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import ErasureRequestsDropdown from '../components/ErasureRequestsDropdown';
export default function extendHeaderSecondary() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.forum.attribute('erasureRequestCount')) {
      items.add('erasureRequests', m(ErasureRequestsDropdown, {
        state: app.erasureRequests
      }), 20);
    }
  });
}
flarum.reg.add('flarum-gdpr', 'forum/extenders/extendHeaderSecondary', extendHeaderSecondary);